import Vue from 'vue'
import { ProviderState, ProviderFilter2, ProviderRecord, ProviderLogEntry } from './types'
import { uploadFile } from '../../services/storage'

const getDefaultState = () => {
    const state: ProviderState = {
        specialties: [],
        providerEntitiesStatus: []
    }
    return state;
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_PROVIDER_ENTITIES_STATUS(state: ProviderState, status: Array<any>) {
            state.providerEntitiesStatus = status;
        },
        SET_PROVIDER_SPECIALTIES(state: ProviderState, status: Array<any>) {
            state.specialties = status;
        },
        RESET_STATE(state: ProviderState) {
            Object.assign(state, getDefaultState())
        }
    },
    actions: {
        async getList({ rootState }, filter: ProviderFilter2) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: string = rootState.auth.entityId;
            if (entityId) {
                params.append('entityId', entityId);
            }
            params.append('name', filter.name);
            params.append('NPI', filter.npi);
            params.append('specialtyId', String(filter.specialtyId));
            /* params.append('insurerMemberId', filter.specialtyId);
             params.append('EMR_ID', filter.EMR_ID);
             params.append('withPhoneErrors', filter.withPhoneErrors ? String(filter.withPhoneErrors) : ""); */
            params.append('pageNumber', String(filter.pageNumber));
            params.append('rowsPerPage', String(filter.rowsPerPage));
            // GET PATIENTS ASYNC
            const { data } = await Vue.axios.post('provider/list', params)
            //
            return data;
        },
        async getProvider({ rootState }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('entityId', rootState.auth.entityId);
            params.append('providerId', String(id));
            // GET PATIENT ASYNC
            const { data } = await Vue.axios.post('provider/list/item', params)
            //
            return data;
        },
        async getLogById({ rootState }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('entityId', rootState.auth.entityId);
            params.append('providerId', String(id));
            // SET GAP LOG ASYNC
            const { data } = await Vue.axios.post('provider/log', params);
            //
            return data;
        },
        /*     async getPhoneStatus({ commit, state }) {
                if (state.phoneStatus.length) return;
                // GET PHONE STATUS LIST ASYNC
                const { data } = await Vue.axios.post('patient/phonestatus/list');
                //
                commit("SET_PHONE_STATUS", data);
            }, */
        async getProviderEntitiesStatus({ commit, state }) {
            if (state.providerEntitiesStatus.length) return;
            // GET  STATUS LIST ASYNC
            const { data } = await Vue.axios.post('provider/entities/status/list');
            //
            commit("SET_PROVIDER_ENTITIES_STATUS", data);
        },
        async getSpecialties({ commit, state }) {
            if (state.specialties.length) return;
            // GET  SPECIALTIES LIST ASYNC
            const { data } = await Vue.axios.post('provider/specialties/list');
            //
            commit("SET_PROVIDER_SPECIALTIES", data);
        },
        async getFiles({ commit }, providerId: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append("providerId", String(providerId));
            // GET PROVIDER FILES ASYNC
            const { data } = await Vue.axios.post("provider/file/list", params);
            //
            return data;
        },
        async getFileUrl({ commit }, { providerId, storageId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append("providerId", providerId);
            params.append("storageId", storageId);
            // GET GAP FILE URL
            const { data } = await Vue.axios.post("provider/file/url", params);
            //
            return data;
        },
        async getFileDownloadUrl({ commit }, { providerId, storageId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append("providerId", providerId);
            params.append("storageId", storageId);
            // GET GAP FILE URL
            const { data } = await Vue.axios.post("provider/file/url/download", params);
            //
            return data;
        },
        async saveLog({ rootState }, entry: ProviderLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('entityId', rootState.auth.entityId);
            params.append('providerId', String(entry.providerId));
            params.append('typeId', entry.typeId);
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('provider/log/save', params);
            //
            return data;
        },
        async saveSystemLog({ rootState }, entry: ProviderLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('entityId', rootState.auth.entityId);
            params.append('patientId', String(entry.providerId));
            params.append('typeId', entry.typeId);
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('provider/log/save/system', params);
            //
            return data;
        },
        async save({ rootState }, provider: ProviderRecord) {
            const params = new FormData();
            // SET FORM DATA
            if (provider.id) {
                params.append('id', String(provider.id));
            }
            params.append('entityId', rootState.auth.entityId);
            params.append('name', provider.name);
            params.append('npi', provider.npi);
            params.append('specialtyId', String(provider.specialtyId));
            params.append('locationId', String(provider.locationId));
            params.append('phone', provider.phone);
            params.append('email', provider.email ? provider.email : "");
            params.append('lang', provider.lang);
            params.append('statusId', provider.statusId)

            // SAVE PROVIDER ASYNC
            const { data } = await Vue.axios.post('provider/save', params);
            //
            return data;
        },
        async saveFile({ rootState }, { provider, file, fileInfo }) {

            const fileId = await uploadFile(rootState.auth.entityId, file);

            const params = new FormData();
            // SET FORM DATA
            params.append('id', String(provider.id));
            params.append('fileId', String(fileId));
            params.append('description', "");
            params.append('reference', fileInfo.reference);
            params.append('type', fileInfo.type);

            // SAVE PATIENT ASYNC
            const { data } = await Vue.axios.post('provider/file/save', params);
            //

            return data;
        },
        async saveFileDesc({ commit }, { providerId, fileId, description }) {
            // SAVE FILE DESC TO DB
            const params = new FormData();
            params.append("providerId", providerId);
            params.append("fileId", fileId);
            params.append("description", description);
            const { data } = await Vue.axios.post("provider/file/desc", params);
            //
            return data;
        },
        async saveFileRef({ commit }, { providerId, fileId, reference }) {
            // SAVE FILE DESC TO DB
            const params = new FormData();
            params.append("providerId", providerId);
            params.append("fileId", fileId);
            params.append("reference", reference);
            const { data } = await Vue.axios.post("provider/file/ref", params);
            //
            return data;
        },
        async archiveFile({ commit }, { providerId, fileId }) {
            // ARCHIVE FILE 
            const params = new FormData();
            params.append("providerId", providerId);
            params.append("fileId", fileId);
            const { data } = await Vue.axios.post("provider/file/archive", params);
            //
            return data;
        }
    }
}
